/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react'

const useDrop = ({ ref, onDrop, onDragLeave, onDragEnter }) => {
  const [dropState, setDropState] = useState('draggable')

  const dropOver = (ev) => {
    ev.preventDefault()
    setDropState('dragging over')
  }

  const drop = (ev) => {
    ev.preventDefault()
    onDrop(ev)
    setDropState('dropped')
  }

  const dragLeave = (ev) => {
    ev.preventDefault()
    setDropState('dragLeave')
    onDragLeave && onDragLeave(ev)
  }

  const dragEnter = (ev) => {
    setDropState('dragEnter')
    onDragEnter && onDragEnter(ev)
  }

  useEffect(() => {
    const elem = ref.current
    if (elem) {
      elem.addEventListener('dragover', dropOver)
      elem.addEventListener('dragenter', dragEnter)
      elem.addEventListener('dragleave', dragLeave)
      elem.addEventListener('drop', drop)
      return () => {
        elem.removeEventListener('dragover', dropOver)
        elem.removeEventListener('dragenter', dragEnter)
        elem.removeEventListener('dragleave', dragLeave)
        elem.removeEventListener('drop', drop)
      }
    }
    return () => {}
  })

  return {
    dropState,
  }
}

export default useDrop
